jQuery(document).ready(function ($) {

    // Mobile menu toggle and close
    $('#mobile-menu-control, .close-mobile-menu').click(function () {

        // Slide the menu and apply open class at the right time.

        if($('header.header-mobile').hasClass('mobile-menu-open')){
            $('#mobile-menu').slideToggle('slow', function () {
                // Animation complete.
                $('header.header-mobile').toggleClass('mobile-menu-open');
            });
        }else{
            $('header.header-mobile').toggleClass('mobile-menu-open');
            $('#mobile-menu').slideToggle('slow', function () {
                // Animation complete.

            });
        }

    });



    $('#mobile-menu .sub-menu-toggle').click(function () {
        $(this).parent().parent().toggleClass('activeMenu');
        $(this).parent().siblings(".sub-menu").slideToggle("100ms", "linear", function () {
            var topBarMobileHeight = $('#top-bar-mobile').css('height');
            var topBarMobileHeight = parseInt(topBarMobileHeight, 10);
            var mobileBannerHeight = $('#mobile-banner').css('height');
            var mobileBannerHeight = parseInt(mobileBannerHeight, 10);
            var windowHeight = $(window).height();
            var mobileMenuHeight = windowHeight - (topBarMobileHeight + mobileBannerHeight) + 'px'

            $('#mobile-menu').css("height", mobileMenuHeight)
            $(".mobile-nav-wrapper").animate({ scrollTop: 0 }, "fast");
        });

        $(this).parent().parent().siblings().children().next().slideUp();
        $(this).parent().parent().siblings('.activeMenu').toggleClass('activeMenu');

    });

}); // end  jQuery(document).ready
